import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resetPassword } from '../services/api';
import { useLang } from '../context/LanguageContext';

export default function ResetPasswordPage({ onDone }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { t } = useLang();
  const r = t.resetPassword;

  const [newPassword, setNewPassword]         = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading]                 = useState(false);
  const [error, setError]                     = useState('');
  const [success, setSuccess]                 = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!newPassword || !confirmPassword) {
      setError(r.errFill);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(r.errMatch);
      return;
    }
    if (newPassword.length < 6) {
      setError(r.errLength);
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || r.errGeneral);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-black text-slate-900 mb-1">{r.title}</h1>

        <div className="card mt-6">
          {success ? (
            <>
              <div className="bg-green-50 border border-green-100 text-green-700 text-sm px-4 py-3 rounded-xl mb-4">
                {r.successMsg}
              </div>
              <button onClick={onDone} className="w-full btn-primary justify-center">{r.backToSignIn}</button>
            </>
          ) : (
            <>
              <p className="text-sm text-slate-500 mb-4">{r.subtitle}</p>
              <form onSubmit={handleSubmit} className="space-y-3">
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder={r.newPassword}
                  autoComplete="new-password"
                  className="w-full border border-slate-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder={r.confirmPassword}
                  autoComplete="new-password"
                  className="w-full border border-slate-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />

                {error && (
                  <div className="bg-red-50 border border-red-100 text-red-600 text-sm px-4 py-3 rounded-xl">{error}</div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="btn-primary w-full justify-center disabled:opacity-50"
                >
                  {loading ? r.updating : r.submitBtn}
                </button>
              </form>
            </>
          )}
        </div>

        {!success && (
          <button
            onClick={onDone}
            className="block mx-auto mt-6 text-sm text-slate-400 hover:text-slate-600 transition-colors"
          >
            {r.backToSignIn}
          </button>
        )}
      </div>
    </div>
  );
}
